import * as UserApi from '@/api/Info'

export default function useChat() {
  const signIn = async (payload) => {
    const res = await UserApi.signIn(payload)
    return res
  }
  const getSignList = async (payload) => {
    const res = await UserApi.getSignList(payload)
    return res
  }
  const signEdit = async (payload) => {
    const res = await UserApi.signEdit(payload)
    return res
  }
  const signUp = async (payload) => {
    const res = await UserApi.signUp(payload)
    return res
  }
  const getUserInfo = async (payload) => {
    const res = await UserApi.getUserInfo(payload)
    return res
  }
  const getMessageList = async (payload) => {
    const res = await UserApi.getMessageList(payload)
    return res
  }
  const messageDelete = async (payload) => {
    const res = await UserApi.messageDelete(payload)
    return res
  }
  const getEmailList = async (payload) => {
    const res = await UserApi.getEmailList(payload)
    return res
  }
  const setEmailList = async (payload) => {
    const res = await UserApi.setEmailList(payload)
    return res
  }
  const signDelete = async (payload) => {
    const res = await UserApi.signDelete(payload)
    return res
  }
  const signOut = async (payload) => {
    const res = await UserApi.signOut(payload)
    return res
  }
  const signEditPassword = async (payload) => {
    const res = await UserApi.signEditPassword(payload)
    return res
  }

  return {
    signIn,
    getSignList,
    signUp,
    signEdit,
    getUserInfo,
    signDelete,
    signOut,
    signEditPassword,
    getMessageList,
    messageDelete,
    getEmailList,
    setEmailList
  }
}
